var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{attrs:{"width":250,"height":370,"thumbnail":"","fluid":"","src":_vm.poster || _vm.defaultPoster,"alt":(_vm.title + " poster")}})}
var staticRenderFns = []

export { render, staticRenderFns }